import { fetchCveApi } from "@utils";

export const getAllPolicies = async ({ setData, setStatus, setError }) => {
	let { data, error } = await fetchCveApi({ path: "/v1/policy" });
	if (error) {
		setStatus("error");
		setError(error);
		return;
	}
	setData(data);
	setStatus("success");
};

export const upsertPolicy = async ({ policy }) => {
	let upsertedPolicy;
	if (policy.policyId) upsertedPolicy = await fetchCveApi({ path: `/v1/policy/${policy.policyId}`, method: "PUT", body: policy });
	else upsertedPolicy = await fetchCveApi({ path: "/v1/policy", method: "POST", body: policy });

	return upsertedPolicy;
};

export const searchCveIds = async (searchStr) => {
	if (searchStr === "") return { data: [] };
	return await fetchCveApi({ path: "/v1/cve/cveIds/search", query: { cveId: searchStr } });
};

export const searchProducts = async (searchStr) => {
	if (searchStr === "") return { data: [] };
	let { data } = await fetchCveApi({ path: "/v1/cve/vendorProducts/search", query: { include: "products", productStartsWith: searchStr } });
	let products = [];

	data.forEach((vp) => {
		if (vp.products.length) products.push(...vp.products);
	});
	return { data: products };
};

export const searchVendors = async (searchStr) => {
	if (searchStr === "") return { data: [] };
	let { data } = await fetchCveApi({ path: "/v1/cve/vendorProducts/search", query: { vendorStartsWith: searchStr } });
	return { data: data.map(({ vendor }) => vendor) };
};

export const deletePolicy = async (policyId) => {
	return await fetchCveApi({ path: `/v1/policy/${policyId}`, method: "delete" });
};
